import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

// Import utilities
import { useIsDesktop, useTranslations } from 'components/utilities';
import useBooking from '../../context/useBooking';

// Import components
import BookingDetailsHeader from './components/BookingDetailsHeader';
import BookingDetailsOffice from './components/BookingDetailsOffice';
import BookingDetailsCar from './components/BookingDetailsCar';
import BookingDetailsDates from './components/BookingDetailsDates';
import BookingDetailsFooter from './components/BookingDetailsFooter';
import BookingAdditionalServices from './components/BookingAdditionalServices';
import { DetailsPolicies, LoadingOverlay } from 'components/elements';

const BookingDetails = () => {
	const { t } = useTranslations();

	const { data: booking, isLoading, isError } = useBooking();

	const isLoaded = !!booking;

	const isDesktop = useIsDesktop();

	const boxPaddings = {
		py: isDesktop ? 4 : 2,
		px: isDesktop ? 12 : 2,
	};

	if (isError) {
		return (
			<Box p={2}>
				<Alert severity="error">{t('errors.unknown')}</Alert>
			</Box>
		);
	}

	if (!isLoaded) {
		return (
			<Box p={2} display="flex" justifyContent="center">
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Box p={isDesktop ? 2 : 0}>
			{isLoading && <LoadingOverlay />}

			<Box>
				<BookingDetailsHeader boxPaddings={boxPaddings} isDesktop={isDesktop} />
			</Box>
			<Box mt={2}>
				<BookingDetailsOffice boxPaddings={boxPaddings} />
			</Box>
			<Box mt={2}>
				<BookingDetailsCar boxPaddings={boxPaddings} isDesktop={isDesktop} />
			</Box>
			<Box mt={2}>
				<BookingDetailsDates boxPaddings={boxPaddings} isDesktop={isDesktop} />
			</Box>
			<Box mt={2}>
				<BookingAdditionalServices boxPaddings={boxPaddings} />
			</Box>
			<Box mt={2}>
				<DetailsPolicies boxSizes={boxPaddings} />
			</Box>
			<Box mt={isDesktop ? 2 : 0}>
				<BookingDetailsFooter boxPaddings={boxPaddings} isDesktop={isDesktop} />
			</Box>
		</Box>
	);
};

export default BookingDetails;
